export const MAP_PROVIDER_KEY = 'visime_map_provider';

/** PARITY(ChoseMapFragment / SingleBusinessFragment): apple ↔ mapSelected 0 (geo/default); google ↔ mapSelected 1 — proof/maps-platform-split.md */
export function openAddressInMaps(addr: {
  latitude: number;
  longitude: number;
  address?: string;
  city?: string;
  country?: string;
}): void {
  if (typeof window === 'undefined') return;
  const parts = [addr.address, addr.city, addr.country].filter(Boolean) as string[];
  const q = parts.length > 0 ? parts.join(', ') : `${addr.latitude},${addr.longitude}`;
  const enc = encodeURIComponent(q);
  const provider = localStorage.getItem(MAP_PROVIDER_KEY) || 'apple';
  if (provider === 'google') {
    window.open(`https://www.google.com/maps/search/?api=1&query=${enc}`, '_blank', 'noopener,noreferrer');
  } else {
    window.open(`https://maps.apple.com/?q=${enc}`, '_blank', 'noopener,noreferrer');
  }
}
